export enum AddressType {
  Mailing = 'Mailing',
  Residential = 'Residential',
  Business = 'Business',
  Commercial = 'Commercial',
}
